module.exports = __webpack_public_path__ + "img/logo-icon-app.a2f12566.png";